module.exports = __webpack_public_path__ + "img/thumbnail_CommonWarthog_j_normal.907343f1.png";